import {CsatEditorBaseErrorsEnum} from '../../../../editors/csatEditor/csatEditorErrors';
import {checkActionValidity} from '../../../ruleActionHelpers';
import {RuleIntegration} from '../../../ruleIntegrationModel';
import {getRuleEditorErrorsForChecks, RuleEditorErrorsEnum} from '../../ruleEditorErrors';
import {CsatEditorSpecificState, CsatEditorState} from './state/csatEditorState';

/*
 * Types.
 */

export const CsatEditorErrorsEnum = {
  // TODO remove when decoupled from ruleEditor
  ...RuleEditorErrorsEnum,
  ...CsatEditorBaseErrorsEnum,
};

export type CsatEditorErrorsEnum =
  // TODO remove when decoupled from ruleEditor
  RuleEditorErrorsEnum | CsatEditorBaseErrorsEnum;

/*
 * Helpers.
 */

export function getCsatEditorErrors(
  state: CsatEditorState,
  ruleIntegration: RuleIntegration,
): ReadonlyArray<CsatEditorErrorsEnum> {
  const ruleEditorErrors = getRuleEditorErrorsForChecks(state, ruleIntegration, [
    'name',
    'conditions',
    'errors',
  ]);

  const csatEditorSpecificErrors = getCsatEditorSpecificErrors(state.csatState, ruleIntegration);

  return [...ruleEditorErrors, ...csatEditorSpecificErrors];
}

function getCsatEditorSpecificErrors(
  state: CsatEditorSpecificState,
  ruleIntegration: RuleIntegration,
): ReadonlyArray<CsatEditorErrorsEnum> {
  const errors: Array<CsatEditorErrorsEnum> = [];

  if (state.delaySinceTrigger.delay?.val === undefined || state.delaySinceTrigger.delay.val === 0) {
    errors.push(CsatEditorErrorsEnum.INVALID_DELAY);
  }

  if (state.response === undefined) {
    errors.push(CsatEditorErrorsEnum.INVALID_RESPONSE);
  }

  if (
    state.actions.scheduled.some(
      (action) => !checkActionValidity(action, ruleIntegration.findActionDefinition(action), []),
    )
  ) {
    errors.push(CsatEditorErrorsEnum.INVALID_SCHEDULED_ACTION);
  }

  if (
    state.actions.sent.some(
      (action) => !checkActionValidity(action, ruleIntegration.findActionDefinition(action), []),
    )
  ) {
    errors.push(CsatEditorErrorsEnum.INVALID_SENT_ACTION);
  }

  return errors;
}
